import { AccountBalance, Business, CalendarToday, CheckCircle, ErrorOutline, Hub as HubIcon, LocationOn, Payment, Person, Save, School, Subscriptions, Wallet, Warning } from "@mui/icons-material";
import { Alert, Avatar, Box, Button, Card, CardContent, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControl, FormControlLabel, FormLabel, Grid, InputLabel, LinearProgress, ListItem, MenuItem, Radio, RadioGroup, Select, Stack, TextField, Tooltip, Typography } from "@mui/material";
import { useDomainActions } from "../../../hooks/useDomainActions";
import { memo, useEffect, useState } from "react";
import { newHub, Hub } from "../../../models/hub";
import { BankAccount, CreateNewBankAccount } from "../../../models/account";
import axios from "axios";
import ConfirmBankAccountDialog from "../components/bank-account-dalog";
import { useClassroomActions } from "../../../hooks/useClassroomActions";
import renderAvatar from "../../../components/render-avatar";
import { Classroom } from "../../../models/classroom";
import ClassroomItem from "../components/classroom-item";
import { useSnackbar } from "../../../components/snackbar";
import BackdropLoader from "../../../components/backdrop-loader";
import isHubActivated from "../../../utils/is-hub-activated";

const API_URL = process.env.REACT_APP_API_URL;

function HubSection() {
  const { hub, bank_account, getHub, getBankAccount, 
  updateHub, addBankAccount } = useDomainActions();

  const { classrooms, getClassrooms, payWithClassroomEarnings } = useClassroomActions();
   
  const [confirmBankAccount, setConfirmBankAccount] = useState(false);
  
  const [loading, setLoading] = useState(false);

  const [banks, setBanks] = useState([]);
  const [locHub, setLocHub] = useState<Hub>(newHub());
  const [bankAccount, setBankAccount] = useState<BankAccount | null>(null);

  const [states, setStates] = useState<any[]>([]);
  const [lgas, setLgas] = useState<any[]>([]);

  const [activationMonths, setActivationMonths] = useState(1);
  const [paymentMethod, setPaymentMethod] = useState<'earnings' | 'external'>('earnings');
  const [selectedClassroomId, setSelectedClassroomId] = useState(0);

  const monthlyRate = 10000;
  
  const totalCost = Math.max(monthlyRate, (Number(activationMonths) || 0) * monthlyRate);

  const selectedClassroomData = selectedClassroomId > 0 ? classrooms?.[selectedClassroomId] : null;

  const { showMessage } = useSnackbar();
  
    
  const hubTypes = [
    { id: 1, name: "Individual", description: "Personal instruction hub" },
    { id: 2, name: "Organization", description: "Institutional hub" },
  ];
  
  const niches = [
    { id: 1, name: "General" },
    { id: 2, name: "Nutrition" },
    { id: 3, name: "Health & Wellness" },
    { id: 4, name: "Technology & Programming" },
    { id: 5, name: "Business & Entrepreneurship" },
    { id: 6, name: "Academic Support (e.g. WAEC, JAMB)" },
    { id: 7, name: "Creative Arts & Design" },
    { id: 8, name: "Languages & Communication" },
    { id: 9, name: "Religious & Spiritual Education" },
    { id: 10, name: "Other" },
  ];
      
  const handleHubChange = (field: keyof Hub, value: any) => {
    setLocHub((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
      
  const handleBankAccountChange = (field: keyof BankAccount, value: any) => {
    if (!bankAccount) {
      setBankAccount(CreateNewBankAccount());
    }
    setBankAccount((prev) => {
      if (!prev) return prev;
      return {
        ...prev,
        [field]: value,
      };
    });
  };
   
  const _updateHub = async () => {
    setLoading(true);
    await updateHub(locHub);
    setLoading(false);
  };
  
  const _addBankAccount = async () => {
    if (!bankAccount) {
      return;
    }
    
    setLoading(true);
    await addBankAccount(bankAccount);
    setLoading(false)
  };

  const formatDate = (dateString: string | null) => {
    if (!dateString) return 'Not set';
    return new Date(dateString).toLocaleDateString('en-NG', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const handleActivation = async () => {
    setLoading(true);
    
    if (paymentMethod === 'earnings') {
      await payWithClassroomEarnings(selectedClassroomId, totalCost);
    }
    else {
      try {
        const response = await axios.get(`${API_URL}/utils/instructors/payment-url?months=${activationMonths}`,
            { withCredentials: true }
        );

          window.open(response.data, '_blank');
      } catch (error) {
        showMessage("An error occurred, please try again", 0);
      }
    }
    
    setLoading(false);
  };
  
  useEffect(() => {
    if (hub) {
      setLocHub(hub);
    }
    
  }, [hub]);

  useEffect(() => {
    if (bank_account) {
      setBankAccount(bank_account);
    }
    
  }, [bank_account]);


  useEffect(() => {
    const loadHubDetails = async () => {
      const promises = [];

      if (!hub) promises.push(getHub());
      if (!bank_account) promises.push(getBankAccount());
      if (!classrooms) promises.push(getClassrooms());

      await Promise.all(promises);
    };

    loadHubDetails();
  }, [getHub, getBankAccount, getClassrooms]);


  useEffect(() => {
    if (bank_account) return;
    const getBanks = async () => {
      try {
        const response = await axios.get('https://api.paystack.co/bank', {
          headers: {
            "Authorization": "Bearer sk_test_ca712b1824b0ac1cb1bf1c0f483f4cc14ecd4391",
            "Content-Type": "application/json"
          }
        });
        setBanks(response.data.data);
        
      } catch (error) {
        console.error("Error fetching banks:", error);
      }
    };

    getBanks();
  }, [bank_account]);

  // useEffect(() => {
  //   fetch("https://vapi.verifyme.ng/v1/countries/1/states")
  //     .then((response) => response.json())
  //     .then((data) => {
  //       if (data.status === "success") {
  //         setStates(data.data);
  //       }
  //     });
  // }, []);
  // useEffect(() => {
  //   if (locHub.state !== 0) {
  //     fetch(`https://vapi.verifyme.ng/v1/states/${locHub.state}/lgas`)
  //       .then((response) => response.json())
  //       .then((data) => {
  //         if (data.status === "success") {
  //           setLgas(data.data);
  //         }
  //       });
  //   }
  // }, [locHub.state]);
  

  return (
      <Stack spacing={2}>
        {!hub && <BackdropLoader/>}

        <Typography 
              variant="subtitle1"
              sx={{
                fontWeight: 600,
                color: 'primary.main',
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                mb: 2
              }}
            >
              <Subscriptions/>
              Hub Activation & Subscription
            </Typography>

            <Divider sx={{ mb: 3 }} />

            <Box sx={{ mb: 4 }}>
              {isHubActivated(hub) !== null && (
                <Chip 
                  icon={isHubActivated(hub) ? <CheckCircle /> : <Warning />}
                  label={isHubActivated(hub) ? "Hub is Active" : "Hub not Activated"}
                  variant={isHubActivated(hub) ? 'filled' : 'outlined'}
                  color={isHubActivated(hub) ? 'success' : 'warning'}
                  sx={{ mb: 3 }}
                />
              )}
              

              <Grid container spacing={2}>
                <Grid size={{ xs: 12, md: 6 }}>
                  <Box sx={{ 
                    p: 2.5, 
                    border: 1, 
                    borderColor: 'divider', 
                    borderRadius: 2,
                    bgcolor: 'white'
                  }}>
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                      <CalendarToday sx={{ fontSize: 16, mr: 1, verticalAlign: 'middle' }} />
                      Subscription Start
                    </Typography>
                    <Typography variant="body1" fontWeight="medium">
                      {formatDate(hub?.subscription_start || null)}
                    </Typography>
                  </Box>
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                  <Box sx={{ 
                    p: 2.5, 
                    border: 1, 
                    borderColor: 'divider', 
                    borderRadius: 2,
                    bgcolor: 'white'
                  }}>
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                      <CalendarToday sx={{ fontSize: 16, mr: 1, verticalAlign: 'middle' }} />
                      Subscription End
                    </Typography>
                    <Typography variant="body1" fontWeight="medium">
                      {formatDate(hub?.subscription_end || null)}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* Activation Form */}
            <Typography variant="h6" gutterBottom sx={{ mb: 3 }}>
              {isHubActivated(hub) ? 'Extend Subscription' : 'Activate Hub'}
            </Typography>
            
            <Grid container spacing={3}>
              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  type="number"
                  label="Number of Months"
                  value={activationMonths}
                  onChange={(e) => setActivationMonths(parseInt(e.target.value))}
                  sx={{ 
                    mb: 2,
                    '& .MuiOutlinedInput-root': {
                      bgcolor: 'white'
                    }
                  }}
                />
                
                <Box sx={{ 
                  p: 2.5, 
                  bgcolor: 'primary.50', 
                  borderRadius: 2,
                  border: 1,
                  borderColor: 'primary.200'
                }}>
                  <Typography variant="body1" fontWeight="medium" color="primary.main">
                    Total Cost: ₦{totalCost ? totalCost.toLocaleString() : "10,000"}
                  </Typography>
                </Box>
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <Box sx={{ 
                  p: 2.5, 
                  bgcolor: 'white', 
                  borderRadius: 2,
                  border: 1,
                  borderColor: 'divider'
                }}>
                  <FormControl fullWidth>
                    <FormLabel sx={{ mb: 2, fontWeight: 600 }}>Payment Method</FormLabel>
                    <RadioGroup
                      value={paymentMethod}
                      onChange={(e) => setPaymentMethod(e.target.value as 'earnings' | 'external')}
                      sx={{ gap: 1 }}
                    >
                      <FormControlLabel 
                        value="earnings" 
                        control={<Radio />} 
                        label={
                          <Box sx={{ ml: 1 }}>
                            <Typography variant="body2" fontWeight="medium">Use Classroom Earnings</Typography>
                            <Typography variant="caption" color="text.secondary">
                              Pay from your existing classroom earnings
                            </Typography>
                          </Box>
                        }
                        sx={{ 
                          p: 1,
                          m: 0,
                          borderRadius: 1,
                          '&:hover': { bgcolor: 'grey.50' }
                        }}
                      />
                      <FormControlLabel 
                        value="external" 
                        control={<Radio />} 
                        label={
                          <Box sx={{ ml: 1 }}>
                            <Typography variant="body2" fontWeight="medium">External Payment</Typography>
                            <Typography variant="caption" color="text.secondary">
                              Pay with external method
                            </Typography>
                          </Box>
                        }
                        sx={{ 
                          p: 1,
                          m: 0,
                          borderRadius: 1,
                          '&:hover': { bgcolor: 'grey.50' }
                        }}
                      />
                    </RadioGroup>
                  </FormControl>
                </Box>

                {paymentMethod === 'earnings' && (
                  <FormControl fullWidth sx={{ mt: 2 }}>
                    <InputLabel>Select Classroom</InputLabel>
                    <Select
                      value={selectedClassroomId}
                      onChange={(e) => setSelectedClassroomId(e.target.value)}
                      label="Select Classroom"
                      sx={{ 
                        bgcolor: 'white',
                        '& .MuiOutlinedInput-notchedOutline': {
                          borderColor: 'divider'
                        }
                      }}
                    >
                      <MenuItem value="">
                        <em>Choose a classroom</em>
                      </MenuItem>
                      {Object.values(classrooms || {}).map((classroom) => (
                        <MenuItem key={classroom.id} value={classroom.id.toString()}>
                          <Box>
                            <Typography variant="body2" fontWeight="medium">{classroom.name}</Typography>
                            <Typography variant="caption" color="text.secondary">
                              Available: ₦{classroom.earnings.toLocaleString()}
                            </Typography>
                          </Box>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}

                {paymentMethod === 'earnings' &&  selectedClassroomData && selectedClassroomData.earnings < totalCost && (
                  <Alert 
                    severity="error"
                    sx={{ 
                      mt: 2,
                      bgcolor: 'error.50',
                      border: 1,
                      borderColor: 'error.200'
                    }}
                  >
                    <strong>Insufficient funds!</strong><br />
                    Available: ₦{selectedClassroomData.earnings.toLocaleString()}<br />
                    Required: ₦{totalCost ? totalCost.toLocaleString() : "10,000"}
                  </Alert>
                )}
              </Grid>
            </Grid>

            <Box sx={{ mt: 4, display: "flex", justifyContent: "flex-end", gap: 2 }}>          
              <Button
                variant="contained"
                size="large"
                startIcon={paymentMethod === 'earnings' ? <Wallet /> : <Payment />}
                onClick={handleActivation}
                disabled={
                  loading || 
                  (paymentMethod === 'earnings' && (selectedClassroomId < 0 || !selectedClassroomData || selectedClassroomData.earnings < totalCost))
                }
                sx={{
                    px: 3,
                    py: 1.5,
                    borderRadius: 2,
                    textTransform: 'none',
                    fontWeight: 600,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    '&:hover': {
                      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                      transform: 'translateY(-1px)'
                    },
                    '&:active': {
                      transform: 'translateY(0)'
                    },
                    transition: 'all 0.2s ease-in-out'
                  }}
              >
                {loading ? (
                  <>
                    <CircularProgress size={16} color="inherit" sx={{ mr: 1 }} />
                    Processing...
                  </>
                ) : (
                  `${isHubActivated(hub) ? 'Extend' : 'Activate'} Hub`
                )}
              </Button>
            </Box>
          
            <Typography 
                variant="subtitle1"
                sx={{
                  fontWeight: 600,
                  color: 'primary.main',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  mb: 2
                }} 
              >
                  <HubIcon/>
                  
                  Primary Details
              </Typography>
  
              <Divider sx={{ mb: 3 }} />

              <Grid container spacing={2} marginTop={2}>
                  <Grid size={{xs: 12, md: 6}}>
                    <TextField
                      fullWidth
                      label="Hub Name"
                      variant="outlined"
                      value={locHub.name}
                      disabled
                      onChange={(e) => handleHubChange("name", e.target.value)}
                      sx={{
                        '& .MuiInputBase-root': {
                          backgroundColor: 'white'
                        }
                      }}
                    />
                  </Grid>

                  <Grid size={{xs: 12, md: 6}}>
                      <FormControl fullWidth>
                      <InputLabel>Hub Type</InputLabel>
                      <Select
                          value={locHub.type || ""}
                          onChange={(e) => handleHubChange("type", Number(e.target.value))}
                          label="Hub Type"
                          disabled
                          sx={{
                            backgroundColor: '#fff'
                          }}
                      >
                          <MenuItem value={0}>
                          <em>Select Hub Type</em>
                          </MenuItem>
                          {hubTypes.map((hubType) => (
                          <MenuItem key={hubType.id} value={hubType.id}>
                              <Stack>
                              <Typography variant="body2" fontWeight="medium">
                                  {hubType.name}
                              </Typography>
                              </Stack>
                          </MenuItem>
                          ))}
                      </Select>
                      </FormControl>
                  </Grid>

                  <Grid size={{xs: 12}}>
                      <FormControl fullWidth>
                      <InputLabel>Specialization</InputLabel>
                      <Select
                          value={locHub.niche || ""}
                          onChange={(e) => handleHubChange("niche", Number(e.target.value))}
                          label="Specialization"
                          disabled
                          sx={{
                            backgroundColor: '#fff'
                          }}
                      >
                          <MenuItem value={0}>
                          <em>Select Specialization</em>
                          </MenuItem>
                          {niches.map((niche) => (
                          <MenuItem key={niche.id} value={niche.id}>
                              {niche.name}
                          </MenuItem>
                          ))}
                      </Select>
                      </FormControl>
                  </Grid>

                  <Grid size={{xs: 12, md: 4}} >
                      <TextField
                          fullWidth
                          label="Country"
                          variant="outlined"
                          value={locHub.country || "Nigeria"}
                          disabled
                          sx={{
                          '& .MuiInputBase-root': {
                            backgroundColor: 'white'
                          }
                        }}
                      />
                  </Grid>
                  <Grid size={{xs: 12, md: 4}} >
                      <FormControl fullWidth>
                      <InputLabel>State</InputLabel>
                      <Select
                          value={locHub.state || ""}
                          disabled
                          onChange={(e) => {
                          const stateId = Number(e.target.value);
                          handleHubChange("state", stateId);
                          handleHubChange("lga", 0);
                          }}
                          label="State"
                          sx={{
                            backgroundColor: '#fff'
                          }}
                      >
                          <MenuItem value={0}>
                          <em>Select State</em>
                          </MenuItem>
                          {states.map((state) => (
                          <MenuItem key={state.id} value={state.id}>
                              {state.name}
                          </MenuItem>
                          ))}
                      </Select>
                      </FormControl>
                  </Grid>
                  <Grid size={{xs: 12, md: 4}} >
                      <FormControl fullWidth disabled={locHub.state === 0}>
                      <InputLabel>Local Government Area</InputLabel>
                      <Select
                          value={locHub.lga || ""}
                          onChange={(e) => handleHubChange("lga", Number(e.target.value))}
                          label="Local Government Area"
                          disabled
                          sx={{
                            backgroundColor: '#fff'
                          }}
                      >
                          <MenuItem value={0}>
                          <em>Select LGA</em>
                          </MenuItem>
                          {lgas.map((lga) => (
                          <MenuItem key={lga.id} value={lga.id}>
                              {lga.name}
                          </MenuItem>
                          ))}
                      </Select>
                      </FormControl>
                  </Grid>
              </Grid>
              
                <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
              <Button
                  variant="contained"
                  startIcon={<Save />}
                  onClick={_updateHub}
                  // disabled={loading}
                  disabled
                  sx={{
                    px: 3,
                    py: 1.5,
                    borderRadius: 2,
                    textTransform: 'none',
                    fontWeight: 600,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    '&:hover': {
                      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                      transform: 'translateY(-1px)'
                    },
                    '&:active': {
                      transform: 'translateY(0)'
                    },
                    transition: 'all 0.2s ease-in-out'
                  }}
              >
                  Update Hub
              </Button>
              </Box>

                    <Typography 
              variant="subtitle1"
                sx={{
                  fontWeight: 600,
                  color: 'primary.main',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  mb: 2
                }} 
            >
              <AccountBalance/>
              
              Payout Details
            </Typography>

            <Divider sx={{ mb: 3 }} />

            <Grid container spacing={2} marginTop={2}>
              <Grid size={{xs: 12, md: 4}} >
                  <TextField
                    fullWidth
                    label="Account Name"
                    variant="outlined"
                    value={bankAccount?.account_name || ""}
                    disabled={bank_account !== null}
                    onChange={(e) => handleBankAccountChange("account_name", e.target.value)}
                    sx={{
                        '& .MuiInputBase-root': {
                          backgroundColor: 'white'
                        }
                      }}
                  />
              </Grid>

              <Grid size={{xs: 12, md: 4}} >
                  <TextField
                    fullWidth
                    label="Account Number"
                    variant="outlined"
                    value={bankAccount?.account_number || ""}
                    disabled={bank_account !== null}
                    onChange={(e) => handleBankAccountChange("account_number", e.target.value)}
                    sx={{
                        '& .MuiInputBase-root': {
                          backgroundColor: 'white'
                        }
                      }}
                  />
              </Grid>

              <Grid size={{xs: 12, md: 4}} >
                <TextField
                    fullWidth
                    select
                    label="Bank Name"
                    variant="outlined"
                    value={bankAccount?.bank_code || ""}
                    disabled={bank_account !== null}
                    onChange={(e) => {
                      const selectedBankCode = e.target.value;
                      const selectedBank: any = banks.find((bank: any) => bank.code === selectedBankCode);

                      handleBankAccountChange("bank_code", selectedBankCode);
                      handleBankAccountChange("bank_name", selectedBank?.name || "");
                    }}
                    sx={{
                        '& .MuiInputBase-root': {
                          backgroundColor: 'white'
                        }
                      }}
                >
                    {banks.map((bank: any) => (
                    <MenuItem key={bank.code} value={bank.code}>
                        {bank.name}
                    </MenuItem>
                    ))}
                </TextField>
              </Grid>
            </Grid>

            {!bank_account && (
              <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
                <Button
                  variant="contained"
                  startIcon={<AccountBalance />}
                  onClick={() => setConfirmBankAccount(true)}
                  disabled={loading || !bankAccount?.account_name || !bankAccount.account_number || !bankAccount.bank_code}
                  sx={{
                    px: 3,
                    py: 1.5,
                    borderRadius: 2,
                    textTransform: 'none',
                    fontWeight: 600,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    '&:hover': {
                      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                      transform: 'translateY(-1px)'
                    },
                    '&:active': {
                      transform: 'translateY(0)'
                    },
                    transition: 'all 0.2s ease-in-out'
                  }}
                >
                  Add Bank Account
                </Button>
              </Box>
            )}

        <Stack sx={{ backgroundColor: 'grey.50', border: "1px solid", borderColor: "divider", padding: 2 }} spacing={2}>
            <Typography 
              variant="subtitle1"
                sx={{
                  fontWeight: 600,
                  color: 'primary.main',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  mb: 2
                }} 
            >
              <School/>
              
              Classrooms
            </Typography>

            <Divider sx={{ mb: 3 }} />

          {Object.values(classrooms || {}).sort((a, b) => new Date(b.created_on).getTime() - new Date(a.created_on).getTime())
          .map((classroom) => (
            <ClassroomItem
              classroom={classroom}
            />
          ))}
        </Stack>
            
        <ConfirmBankAccountDialog
          open={confirmBankAccount}
          setOpen={setConfirmBankAccount}
          onProceed={_addBankAccount}
        />

      </Stack>
  )
}

export default memo(HubSection);